import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StoreMallDirectoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"store_mall_directory"}/>
}
